import React from "react";
import { motion } from "framer-motion";
import { ExternalLink, Sparkles } from "lucide-react";

const WhyTrustUs = () => {
  return (
    <section id="why-trust" className="relative z-10 scroll-mt-28 overflow-hidden bg-[#0B0F19] py-24 md:py-32" data-testid="why-trust-section">
      <div className="pointer-events-none absolute left-1/2 top-1/3 h-[500px] w-[760px] -translate-x-1/2 bloom-indigo opacity-40" />

      <div className="mx-auto max-w-4xl px-6 text-center md:px-10">
        <motion.span
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-sans text-xs uppercase tracking-[0.3em] text-[#D4AF37]"
        >
          Why trust us
        </motion.span>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mx-auto mt-5 max-w-3xl font-serif text-4xl leading-[1.1] tracking-tight text-[#F3EEE3] md:text-5xl"
        >
          Behind the speed is{" "}
          <span className="italic text-[#D4AF37]">2.5 decades of trust</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="mx-auto mt-7 max-w-2xl font-sans text-base leading-relaxed text-[#A9B0C2]"
        >
          Behind <span className="text-[#F3EEE3]">diwaligiftsintwodays.com</span> is{" "}
          <span className="text-[#D4AF37]">Consortium Gifts</span> — India&rsquo;s pioneer in
          corporate gifting for over two and a half decades. Every express order is curated,
          quality-checked and fulfilled by the same team that gifts for the country&rsquo;s
          largest enterprises.
        </motion.p>
      </div>

      {/* Bridge CTA box */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
        className="mx-auto mt-14 max-w-3xl px-6 md:px-10"
      >
        <div className="glass relative overflow-hidden rounded-2xl border border-[#F3E5AB]/15 p-8 text-center md:p-12">
          <div className="pointer-events-none absolute left-1/2 top-0 h-40 w-96 -translate-x-1/2 bloom-gold opacity-40" />
          <div className="relative">
            <Sparkles className="mx-auto mb-5 h-7 w-7 text-[#D4AF37]" strokeWidth={1.5} />
            <p className="mx-auto max-w-xl font-serif text-2xl leading-snug tracking-tight text-[#F3EEE3] md:text-3xl">
              Looking for bespoke customization, bulk corporate branding, or global shipping beyond 2 days?
            </p>
            <a
              href="https://www.consortiumgifts.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="consortium-external-cta"
              className="btn-gold mt-8 inline-flex items-center gap-2 rounded-full px-9 py-4 font-sans text-sm font-semibold tracking-wide"
            >
              Visit ConsortiumGifts.com for Global &amp; Custom Orders
              <ExternalLink className="h-4 w-4" strokeWidth={2.2} />
            </a>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default WhyTrustUs;
